import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Body, CardContainer, ProgressbarWrapper } from './style';
import { Categories } from '../style';
import routes from '../../../../routes';
import ProgressBar from '../../ProgressBar';
import theme from '../../../theme';
import Text from '../../Text';
import MultiActions from '../../MultiActions';

const CardCoursesSmall = ({ data, onClick, onClickLeave }) => {
  const navigate = useNavigate();

  return (
    <CardContainer>
      <Body>
        <Text type="h3" className="ellipsis" onClick={onClick}>
          {data.title}
        </Text>
        <Categories style={{ marginBottom: '0' }} className="ellipsis">
          {(data?.categories || []).slice(0, 3).map((category, index) => (
            <span key={`cat-sm-${index}`}>
              {index === 0 ? '' : '- '}
              {category?.label}{' '}
            </span>
          ))}
        </Categories>
      </Body>
      <MultiActions
        actions={[
          {
            label: 'Riprendi',
            icon: 'arrow-circle-right',
            onClick: () => {
              navigate(`${routes.courseDetails.path}/${data?.id}/panoramica`);
            },
          },
          {
            label: 'Abbandona',
            icon: 'x-circle',
            onClick: onClickLeave,
          },
        ]}
      />
      <ProgressbarWrapper>
        <ProgressBar
          percentage={Math.round((data?.completion?.rate || 0) * 100)}
          color={theme().colors.title}
          bgColor="#D1D1D1"
        />
      </ProgressbarWrapper>
    </CardContainer>
  );
};

CardCoursesSmall.propTypes = {
  data: PropTypes.object,
  onClick: PropTypes.func,
  onClickLeave: PropTypes.func,
};

export default CardCoursesSmall;
